import * as BABYLON from '@babylonjs/core';
import { scene as rendererScene } from './renderer';
import * as GUI from '@babylonjs/gui';
import { restoreHoverOverlay, suspendHoverOverlay } from './modularFurniture';
const isDimensionsEqual = (a, b) => a.x === b.x && a.y === b.y && a.z === b.z;
const createCustomButton = (interaction, brandColour, scene) => {
    const result = new GUI.Button(interaction.identifier);
    const background = new GUI.Rectangle(`${interaction.identifier}-bg-container`);
    background.width = '30px';
    background.height = '30px';
    result.addControl(background);
    const icon = new GUI.Image(`${interaction.identifier}-icon-container`, interaction.image);
    icon.width = interaction.isActive ? '61px' : '51px';
    icon.height = interaction.isActive ? '61px' : '51px';
    icon.color = 'transparent';
    icon.onImageLoadedObservable.add(() => background.background = interaction.isActive ? brandColour : '#18181B');
    background.background = icon.isLoaded ? interaction.isActive ? brandColour : '#18181B' : 'transparent';
    result.addControl(icon);
    result.pointerEnterAnimation = () => { };
    result.width = interaction.isActive ? '61px' : '51px';
    result.height = interaction.isActive ? '61px' : '51px';
    result.color = 'transparent';
    result.onPointerClickObservable.add(() => interaction.onClick());
    result.onPointerEnterObservable.add(() => {
        scene.meshes.forEach(suspendHoverOverlay);
    });
    result.onPointerOutObservable.add(() => {
        scene.meshes.forEach(restoreHoverOverlay);
    });
    return result;
};
const applyButtonToTexture = (button, guiLayer, interaction, scene) => {
    guiLayer.addControl(button);
    const buttonNode = new BABYLON.TransformNode(interaction.identifier, scene);
    buttonNode.position = new BABYLON.Vector3(interaction.position.x, interaction.position.y, interaction.position.z);
    button.linkWithMesh(buttonNode);
};
export const renderSceneButtons = (renderer, buttons, brandColour) => {
    if (renderer === undefined) {
        return;
    }
    const _scene = rendererScene(renderer);
    const guiLayer = _scene.getTextureByName('sceneButtons') ?? GUI.AdvancedDynamicTexture.CreateFullscreenUI('sceneButtons');
    const buttonsInScene = guiLayer.getControlsByType('Button');
    const obsoleteButtonsInScene = buttonsInScene.filter(c => {
        return !buttons.map(b => b.identifier).includes(c.name);
    });
    obsoleteButtonsInScene.forEach(c => {
        const controlButton = guiLayer.getControlsByType('Button').filter(b => b.name === c.name);
        controlButton.forEach(b2 => {
            b2.clearControls();
        });
        c.linkWithMesh(null);
        guiLayer.removeControl(c);
        c.dispose();
    });
    buttons.forEach(interaction => {
        const buttonInScene = buttonsInScene.find(b => b.name === interaction.identifier);
        if (buttonInScene === undefined) {
            const button = createCustomButton(interaction, brandColour, _scene);
            applyButtonToTexture(button, guiLayer, interaction, _scene);
            return;
        }
        if (buttonInScene !== undefined) {
            const currentPosition = buttonInScene.linkedMesh?.position;
            const newProposedPosition = new BABYLON.Vector3(interaction.position.x, interaction.position.y, interaction.position.z);
            const isPositionChanged = currentPosition !== undefined && !isDimensionsEqual(currentPosition, newProposedPosition);
            const isActiveChanged = interaction.isActive && buttonInScene.width !== '61px' || !interaction.isActive && buttonInScene.width === '61px';
            if (isPositionChanged || isActiveChanged) {
                buttonInScene.linkWithMesh(null);
                guiLayer.removeControl(buttonInScene);
                buttonInScene.dispose();
                const button = createCustomButton(interaction, brandColour, _scene);
                applyButtonToTexture(button, guiLayer, interaction, _scene);
                return;
            }
        }
    });
};
